import { render, staticRenderFns } from "./DialogUserDelete.vue?vue&type=template&id=261c6b12&"
import script from "./DialogUserDelete.vue?vue&type=script&lang=js&"
export * from "./DialogUserDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports